import React, { ChangeEvent } from 'react';
import { useField, useFormikContext } from 'formik';

import Error from './FormItemError';
import InputNumber, { InputNumberProps } from '../components/InputNumber';
import Label from '../components/Label';
import FieldProps from './FieldProps';

import './FormikStyles.less';

type Props = InputNumberProps &
  FieldProps & {
    hint?: string;
    size?: number | undefined;
    onChange?: ((event: ChangeEvent<HTMLInputElement>) => void) | undefined;
    prefix?: string;
    suffix?: string;
    precision?: number;
  };

const FormikInputNumberField: React.FC<Props> = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const showError = meta.touched && meta.error;
  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>;
  const id = props.id || props.name;

  const onChange = (value: string | number | undefined) => {
    setFieldValue(props.name, value);
    if (props.onChange) props.onChange(value);
  };

  const hint = props.hint ? (
    <span className="formik-field__span"> {props.hint}</span>
  ) : null;

  return (
    <>
      <Label
        htmlFor={id}
        className="formik-field__input-label no-select hand-on-hover mr-8"
      >
        {props.label}
        {hint}
      </Label>
      <InputNumber
        {...field}
        {...props}
        id={id}
        onChange={onChange}
        placeholder={props.placeholder}
        className={`${showError && 'border_error'} `}
        precision={props.precision}
      />
      <div className="mb-16  mt-8">{error}&nbsp;</div>
    </>
  );
};

export default FormikInputNumberField;
